import IComponent from "components/commons/IComponent";
import "./SplitScreen.scoped.css";
import LayerSetting from "components/LayerSetting";
import SwitchButton from "components/commons/SwitchButton";
import { toggleSplitMapType } from "store/globalSlice";

let active = undefined;
let watches = [];
class ClassName extends IComponent {
  constructor(props) {
    super(props);
    this.state = { showActiveItem: false };
  }

  componentDidMount() {
    this.mapToolBarStatusChange(true);
  }

  componentWillUnmount() {
    this.mapToolBarStatusChange(false);
  }

  componentDidUpdate(prevProp) {
    if (prevProp.mapView2 != this.props.mapView2) {
      let vm = this;
      watches.forEach((i) => i.remove());
      watches = [];
      let { mapView, mapView2 } = this.props;

      let views = [mapView, mapView2];
      for (const view of views) {
        view.watch(["interacting", "animation"], () => {
          active = view;
          vm.syncViewpoint(active);
        });

        watches.push(view.watch("viewpoint", () => vm.syncViewpoint(view)));
      }

      active = mapView;
      mapView2.when(() => vm.syncViewpoint(mapView));

      let gLyr_MMS = mapView.map.allLayers.find(
        (i) => i.id == "highlightLayerForMMS"
      );
      let gLyr_District = mapView.map.allLayers.find(
        (i) => i.id == "highlightLayerForDistrict"
      );

      gLyr_MMS.graphics.forEach((i) => {
        mapView2.graphics.add(i.clone());
      });
      gLyr_District.graphics.forEach((i) => {
        mapView2.graphics.add(i.clone());
      });
    }
  }

  syncViewpoint(source) {
    let { mapView, mapView2 } = this.props;
    let views = [mapView, mapView2];

    if (!active || !active.viewpoint || active !== source) {
      return;
    }

    for (const view of views) {
      if (view !== active) {
        view.viewpoint = active.viewpoint;
      }
    }
  }

  mapToolBarStatusChange(isMounting) {
    let layer3DPanel = document?.querySelector(
      ".esri-ui-corner.new3DLayerPanelExpandContainer.esri-component"
    );
    layer3DPanel && (layer3DPanel.style.display = isMounting ? "none" : "");

    let actionBar = document.querySelector(
      ".actionBtns.spacer.EqualWidthChildren"
    );
    actionBar.classList[isMounting ? "add" : "remove"]("disabled");
  }

  render() {
    let { showActiveItem } = this.state;
    let map2Type = this.props.reduxStore.global.map2Type;
    return (
      <div className="SplitScreenContainer">
        <div className="EqualWidthChildren">
          <div className="PanelTitle">
            <div>
              Split Layer List
              <br />
              (Left side map)
            </div>
            {map2Type === 3 && (
              <div className="LeftMapSwitchModeButton">
                <div
                  className={`icon_l ${
                    map2Type == 2 ? "icn_2d_goto3d" : "icn_3d_goto2d"
                  }`}
                  onClick={() => this.props.reduxCallProxy(toggleSplitMapType)}
                />
              </div>
            )}
          </div>
          <div
            className="PanelTitle"
            style={{ backgroundColor: "var(--lightYellow)" }}
          >
            <div>
              Split Layer List
              <br />
              (Right side map)
            </div>
          </div>
        </div>
        <div className="SubPanelContent BottomLine">
          <div className="EqualWidthChildren">
            <SwitchButton
              label="Show Active Items Only"
              checked={showActiveItem}
              onClick={() => {
                this.setState({ showActiveItem: !showActiveItem });
              }}
            />
            <div className="AlignRight">
              <div
                style={{ cursor: "pointer" }}
                className="icn_3d_Elevationprofile_close CloseBtn IconColor"
                onClick={() => this.props.switchPanel(1)}
              />
            </div>
          </div>
        </div>
        <div
          className="EqualWidthChildren"
          style={{ height: "100%", overflow: "hidden" }}
        >
          <LayerSetting
            {...this.props}
            mapType={map2Type}
            mapView={this.props.mapView2}
            isSecondMap={true}
            isActiveOnly={showActiveItem}
          />
          <div className="SplitLine" />
          <LayerSetting
            {...this.props}
            mapType={this.props.mapType}
            mapView={this.props.mapView}
            isSecondMap={false}
            isActiveOnly={showActiveItem}
          />
        </div>
      </div>
    );
  }
}

export default ClassName;
